var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.2108 78.7894C62.6335 78.1207 79.4579 60.2121 78.7892 38.7894C78.1205 17.3667 60.2118 0.542325 38.7892 1.21105C17.3665 1.87977 0.542106 19.7884 1.21083 41.2111C1.87955 62.6337 19.7882 79.4581 41.2108 78.7894Z",
    fill: "#22A08C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8509 61.998C53.8509 63.0066 53.0331 63.8249 52.0245 63.8249H24.7962C23.7876 63.8249 22.9697 63.0066 22.9697 61.998V20.492C22.9697 19.4834 23.7872 18.6655 24.7962 18.6655H52.0245C53.0331 18.6655 53.8509 19.483 53.8509 20.492V61.998Z",
    fill: "#B4BE1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0336 59.5132C57.0336 60.5226 56.2162 61.3392 55.2072 61.3392H27.9793C26.9703 61.3392 26.1528 60.5226 26.1528 59.5132V18.0075C26.1528 16.9981 26.9703 16.1807 27.9793 16.1807H55.2072C56.2158 16.1807 57.0336 16.9981 57.0336 18.0075V59.5132Z",
    fill: "#ECEDBE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M41.7893 16.1807H27.9793C26.9703 16.1807 26.1528 16.9981 26.1528 18.0071V59.5128C26.1528 60.5221 26.9703 61.3388 27.9793 61.3388H41.7893V16.1807Z",
    fill: "#B4BE1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 27.4759C53.604 27.4759 53.9326 27.1478 53.9326 26.7424C53.9326 26.3379 53.6044 26.0093 53.1995 26.0093H41.7871V27.4764L53.1995 27.4759Z",
    fill: "#22A08C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 31.34C53.604 31.34 53.9326 31.0114 53.9326 30.6065C53.9326 30.2011 53.6044 29.8726 53.1995 29.8726H41.7871V31.34H53.1995Z",
    fill: "#22A08C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 35.2039C53.604 35.2039 53.9326 34.8753 53.9326 34.4703C53.9326 34.0658 53.6044 33.7368 53.1995 33.7368H41.7871V35.2039H53.1995Z",
    fill: "#22A08C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 39.0681C53.604 39.0681 53.9326 38.7391 53.9326 38.3345C53.9326 37.9288 53.6044 37.6006 53.1995 37.6006H41.7871V39.0681H53.1995Z",
    fill: "#22A08C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 42.9319C53.604 42.9319 53.9326 42.6037 53.9326 42.198C53.9326 41.7934 53.6044 41.4648 53.1995 41.4648H41.7871V42.9319H53.1995Z",
    fill: "#22A08C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 46.7958C53.604 46.7958 53.9326 46.4672 53.9326 46.0618C53.9326 45.6573 53.6044 45.3291 53.1995 45.3291H41.7871V46.7962L53.1995 46.7958Z",
    fill: "#22A08C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 50.6603C53.604 50.6603 53.9326 50.3317 53.9326 49.9259C53.9326 49.5218 53.6044 49.1924 53.1995 49.1924H41.7871V50.6603H53.1995Z",
    fill: "#22A08C"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1995 54.5232C53.604 54.5232 53.9326 54.1954 53.9326 53.7897C53.9326 53.3847 53.6044 53.0562 53.1995 53.0562H41.7871V54.5232H53.1995Z",
    fill: "#22A08C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5916 19.2861H41.7886V23.6893H49.5916C50.6006 23.6893 51.4181 22.8715 51.4181 21.8633V21.113C51.4181 20.1032 50.6006 19.2861 49.5916 19.2861Z",
    fill: "#EE563D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9851 19.2855C32.9766 19.2855 32.1587 20.1026 32.1587 21.112V21.8623C32.1587 22.8705 32.9762 23.6884 33.9851 23.6884H41.7882V19.2852L33.9851 19.2855Z",
    fill: "#EE563D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M33.9851 19.2855C32.9766 19.2855 32.1587 20.1026 32.1587 21.112V21.8623C32.1587 22.8705 32.9762 23.6884 33.9851 23.6884H41.7882V19.2852L33.9851 19.2855Z",
    fill: "#EE563D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 26.7417C29.251 27.1471 29.5796 27.4753 29.9849 27.4753H41.7882V26.0078H29.9849C29.58 26.0082 29.251 26.3372 29.251 26.7417Z",
    fill: "#22A08C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 26.7417C29.251 27.1471 29.5796 27.4753 29.9849 27.4753H41.7882V26.0078H29.9849C29.58 26.0082 29.251 26.3372 29.251 26.7417Z",
    fill: "#22A08C"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 30.6065C29.251 31.0114 29.5796 31.34 29.9849 31.34H41.7882V29.8726H29.9849C29.58 29.8726 29.251 30.2011 29.251 30.6065Z",
    fill: "#22A08C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 30.6065C29.251 31.0114 29.5796 31.34 29.9849 31.34H41.7882V29.8726H29.9849C29.58 29.8726 29.251 30.2011 29.251 30.6065Z",
    fill: "#22A08C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 34.4703C29.251 34.8757 29.5796 35.2039 29.9849 35.2039H41.7882V33.7368H29.9849C29.58 33.7364 29.251 34.0654 29.251 34.4703Z",
    fill: "#22A08C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 34.4703C29.251 34.8757 29.5796 35.2039 29.9849 35.2039H41.7882V33.7368H29.9849C29.58 33.7364 29.251 34.0654 29.251 34.4703Z",
    fill: "#22A08C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 38.3345C29.251 38.7391 29.5796 39.0681 29.9849 39.0681H41.7882V37.6006H29.9849C29.58 37.6006 29.251 37.9288 29.251 38.3345Z",
    fill: "#22A08C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 38.3345C29.251 38.7391 29.5796 39.0681 29.9849 39.0681H41.7882V37.6006H29.9849C29.58 37.6006 29.251 37.9288 29.251 38.3345Z",
    fill: "#22A08C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 42.197C29.251 42.6027 29.5796 42.9313 29.9849 42.9313H41.7882V41.4639H29.9849C29.58 41.4643 29.251 41.7925 29.251 42.197Z",
    fill: "#22A08C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 42.197C29.251 42.6027 29.5796 42.9313 29.9849 42.9313H41.7882V41.4639H29.9849C29.58 41.4643 29.251 41.7925 29.251 42.197Z",
    fill: "#22A08C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 46.0613C29.251 46.4666 29.5796 46.7956 29.9849 46.7956H41.7882V45.3281H29.9849C29.58 45.3281 29.251 45.6571 29.251 46.0613Z",
    fill: "#22A08C"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 46.0613C29.251 46.4666 29.5796 46.7956 29.9849 46.7956H41.7882V45.3281H29.9849C29.58 45.3281 29.251 45.6571 29.251 46.0613Z",
    fill: "#22A08C"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 49.926C29.251 50.3314 29.5796 50.6599 29.9849 50.6599H41.7882V49.1929H29.9849C29.58 49.1925 29.251 49.5219 29.251 49.926Z",
    fill: "#22A08C"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 49.926C29.251 50.3314 29.5796 50.6599 29.9849 50.6599H41.7882V49.1929H29.9849C29.58 49.1925 29.251 49.5219 29.251 49.926Z",
    fill: "#22A08C"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.251 53.7897C29.251 54.1954 29.5796 54.5232 29.9849 54.5232H41.7882V53.0562H29.9849C29.58 53.0562 29.251 53.3851 29.251 53.7897Z",
    fill: "#22A08C"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.29,
    d: "M29.251 53.7897C29.251 54.1954 29.5796 54.5232 29.9849 54.5232H41.7882V53.0562H29.9849C29.58 53.0562 29.251 53.3851 29.251 53.7897Z",
    fill: "#22A08C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemp);
export default __webpack_public_path__ + "static/media/attemp.9d62d719054a75630755deadbff6a4ee.svg";
export { ForwardRef as ReactComponent };